import { PageId } from 'constants/pages'

export const enum PageIdWoofzCoaching {
  DOG_SELECTOR = PageId.DOG_SELECTOR,
  PROBLEM_DESCRIPTION = PageId.PROBLEM_DESCRIPTION,
  DOG_BREED_COACHING = PageId.DOG_BREED_COACHING,
  DOG_AGE_COACHING = PageId.DOG_AGE_COACHING,
  DOG_PROFILE_COACHING = PageId.DOG_PROFILE_COACHING,
  SUBSCRIPTIONS_COACHING = PageId.SUBSCRIPTIONS_COACHING,
  CANCEL_OFFER_COACHING = PageId.CANCEL_OFFER_COACHING,
  CALENDLY_COACHING = PageId.CALENDLY_COACHING,
  ALL_SET_COACHING = PageId.ALL_SET_COACHING,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
